import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import { queryTimeZoom, querylwTeacherTime, editlwTeacherTime, editFreeTimeTemplate, queryFreeTimeTemplate } from '@/api'
@Component({ name: 'schedule-page' })
export default class SchedulePage extends Vue {
  private searchData: any = { // 搜索data
    timeAreaChoose: 8,
    teacherId: ''
  }

  private teachingScheduleButton = false
  private selectFlag = false // 当参数为true时，mouseover事件生效
  private max: any = {
    x: 0,
    y: 0
  }

  private selectStart: any = []
  private showTypeChoose = '周'
  private timeAreaOptions = []
  private showPanelDayrelation: any = {}
  private spareTimeTemplate: any = {
    timeAreaChoose: 8,
    formTime: '',
    toTime: '',
    checkedWeekList: [],
    timeTemplateList: [{ startAt: '', endAt: '' }]
  }

  private freeTimeList: any = []
  private timetableDialogVisible: any = false
  private weekList: any = [{ val: 1, name: '每周一' }, { val: 2, name: '每周二' }, { val: 3, name: '每周三' }, { val: 4, name: '每周四' }, { val: 5, name: '每周五' }, { val: 6, name: '每周六' }, { val: 7, name: '每周日' }]
  private teacherName: any = ''
  private scheduleListWeek: any = []
  private currentChoose: any = null
  private timeList: any = []
  private courseList = []
  private weekI: any = 0;
  private pageType: any = ''

  created () {
    if (this.$route.query.teacherId) {
      this.searchData.teacherId = this.$route.query.teacherId
      this.teacherName = this.$route.query.teacherName
    }
    // 1.主导师 2.Mentor库 3.论文导师库 4.科研助教导师
    this.pageType = this.$route.query.pageType // 论文导师可编辑排课时间
    this.initTimeList()
    this.queryTimeZoom()
    this.currentChoose = moment()
    this.onScheduleTypeChange()
  }

  // 鼠标开始滑动
  private mousedown (index: any, key: any) {
    this.selectStart = []
    this.selectFlag = true
    if (!this.scheduleListWeek[index].time[key].value) {
      if (this.scheduleListWeek[index].time[key].isSelected) {
        this.$set(this.scheduleListWeek[index].time[key], 'isSelected', false)
      } else {
        this.$set(this.scheduleListWeek[index].time[key], 'isSelected', true)
      }
    }
    this.selectStart.push({
      index: index,
      key: key
    })
  }

  // 鼠标移动事件
  private mouseover (index: any, key: any) {
    // x 垂直方向  y 水平方向
    if (this.selectFlag) {
      if (index >= this.max.x) {
        this.max.x = index
      }
      if (key >= this.max.y) {
        this.max.y = key
      }
      const start = {
        x: this.selectStart[0].index,
        y: this.selectStart[0].key
      }
      const end = {
        x: index,
        y: key
      }
      for (let i = end.x; i <= this.max.x; i++) {
        for (let j = end.y; j <= this.max.y; j++) {
          if (!this.scheduleListWeek[i].time[j].value) { // 直接已经选中的数据不取消
            this.$set(this.scheduleListWeek[i].time[j], 'isSelected', false)
          }
        }
      }
      /* 渲染选中的区域 */
      for (let i = start.x; i <= end.x; i++) {
        for (let j = start.y; j <= end.y; j++) {
          if (!this.scheduleListWeek[i].time[j].value) {
            this.$set(this.scheduleListWeek[i].time[j], 'isSelected', true)
          }
        }
      }
    }
  }

  // 鼠标拖拽结束事件
  private async mouseup () {
    this.selectFlag = false
    this.max = {
      x: 0,
      y: 0
    }
    const list: any = []
    this.scheduleListWeek.forEach((item: any) => {
      const obj: any = {}
      obj.time = item.day
      obj.isToday = item.isToday
      obj.month = item.month
      obj.week = item.week
      obj.freeTime = []
      obj.year = item.year
      obj.timeStr = item.year + '-' + item.month + '-' + item.day
      if (item.time.length > 0) {
        item.time.forEach((item1: any) => {
          if (item1.isSelected) {
            obj.freeTime.push(item1) // 获取每列选中的数据。
          }
        })
        if (obj.freeTime.length > 0) {
          const list1 = this.getfz(obj, obj.freeTime) // 拼接每列数据选中的长度。
          obj.freeTime = list1
          list.push(obj)
        } else {
          list.push(obj)
        }
      }
    })
    this.freeTimeList = list // 获取选中的空闲日期。
  }

  // 课表总拖拽连续的方块分组。
  private getfz (obj: any, arr: any) {
    const result: any = []; let i = 0
    const list = arr
    list.forEach((item: any, index: any) => {
      if (index === 0) {
        result[0] = [item]
      } else if (Number(item.time.split(':')[0]) - Number(list[index - 1].time.split(':')[0]) === 1) { // 判断当前值 和 前一个值是否相差1
        result[i].push(item)
      } else {
        result[++i] = [item]
      }
    })
    const list1: any = []
    result.forEach((item: any) => {
      const obj: any = {}
      obj.startPoint = item[0].time.replace(':', '.')
      obj.classHour = item.length
      list1.push(obj)
    })
    return list1
  }

  private async queryTimeZoom () {
    // 查询时区
    const result: any = await queryTimeZoom({})
    this.timeAreaOptions = result.zoneList
  }

  private async initTimeList () {
    this.timeList = []
    for (let index = 0; index <= 23; index++) {
      const obj: any = {
        time: `${index}:00`,
        value: false
      }
      this.timeList.push(obj)
    }
  }

  private async initScheduleList () {
    this.scheduleListWeek = await this.monthWeek(this.currentChoose)
    this.scheduleListWeek.forEach((item: any) => {
      // this.timeList 是时间格，飘窗都是定位出来的。
      const list = JSON.parse(JSON.stringify(this.timeList))
      const obj: any = this.courseList.find((item1: any) => item.week === item1.week || (item.week === '0' && item1.week === '7')) // 获取当前某一列和有课表的一列数据
      if (obj) {
        if (obj.timeTable.length) {
          obj.timeTable.forEach((element: any) => {
            const index1 = Number(element.startPoint.split('.')[0])
            const index2 = Number(element.startPoint.split('.')[0]) + parseInt(element.classHour)
            for (let i = index1; i < index2; i++) { // 已排课时间不可编辑。
              this.$set(list[i], 'value', true)
            }
          })
        }
        // // 已排课的数据加背景色
        if (obj.freeTime.length) {
          obj.freeTime.forEach((item2: any) => {
            const index3 = Number(item2.startPoint.split('.')[0])
            const index4 = Number(item2.startPoint.split('.')[0]) + parseInt(item2.classHour)
            for (let i = index3; i < index4; i++) {
              this.$set(list[i], 'isSelected', true)
            }
          })
        }
      }
      this.$set(item, 'time', list)
    })
  }

  // 修改可排课时间
  private async editingTime () {
    if (this.freeTimeList.length < 1) {
      this.mouseup()// 如果没有拖动鼠标数据初始化。
    }
    await editlwTeacherTime({ teacherId: this.searchData.teacherId, timeZone: this.searchData.timeAreaChoose, timeTable: this.freeTimeList })
    this.$message({ message: '修改空余时间成功', type: 'success' })
    this.teachingScheduleButton = false
  }

  // 查看模版
  private async queryTemplate () {
    const result: any = await queryFreeTimeTemplate({ teacherId: this.$route.query.teacherId })
    if (result && result.template) {
      this.spareTimeTemplate = {
        timeAreaChoose: result.template.timeZone,
        formTime: result.template.startDate,
        toTime: result.template.endDate,
        checkedWeekList: result.template.weeks,
        timeTemplateList: result.template.times
      }
    }
    this.timetableDialogVisible = true
  }

  // 添加模版时间段
  private addTime (type: any, index: any) {
    if (type) { // 删除
      this.spareTimeTemplate.timeTemplateList.splice(index, 1)
    } else { // 增加
      const obj = {
        startAt: '', endAt: ''
      }
      this.spareTimeTemplate.timeTemplateList.push(obj)
    }
  }

  // 保存时间模版
  private async onExportClicked (type: any) {
    const obj = {
      isSave: type,
      teacherId: this.searchData.teacherId, // 老师id
      timeZone: this.spareTimeTemplate.timeAreaChoose, // 时区 中国 = 8 默认是8
      startDate: this.spareTimeTemplate.formTime, // 开始日期
      endDate: this.spareTimeTemplate.toTime, // 结束日期
      weeks: this.spareTimeTemplate.checkedWeekList, // 每周包含的周几
      times: this.spareTimeTemplate.timeTemplateList
    }
    const { error }: any = await editFreeTimeTemplate(obj)
    if (!error) {
      this.$message({ message: '保存成功', type: 'success' })
      this.timetableDialogVisible = false
      this.onScheduleTypeChange()
    }
  }

  closeDialog () {
    this.spareTimeTemplate.timeTemplateList = [{ startAt: '', endAt: '' }]
  }

  private async initSummaryTimetable () {
    const obj: any = {
      week: this.weekI,
      timeZone: this.searchData.timeAreaChoose,
      teacherId: this.searchData.teacherId
    }
    const projectTesult: any = await querylwTeacherTime(obj)
    this.courseList = projectTesult.weekList
  }

  get today () {
    return moment()
  }

  get currentDate () {
    return moment(this.currentChoose).format('YYYY年MM月')
  }

  monthWeek (date: any) {
    const dateList = []
    // 看一下今天星期几
    const nowWeek = moment(date).weekday() === 0 ? 7 : moment(date).weekday()
    // 本周的第一天是
    const firstDayOfWeek = moment(date).subtract(nowWeek, 'day')
    for (let index = 0; index < 7; index++) {
      const buffer = firstDayOfWeek.add(1, 'day')
      dateList.push({
        day: buffer.format('D'),
        month: buffer.format('M'),
        year: buffer.format('YYYY'),
        week: buffer.format('d'),
        isToday: buffer.format('YYYYMMDD') === moment().format('YYYYMMDD')
      })
    }
    return dateList
  }

  // 时区被切换
  private onTimeAreaChange (data: any) {
    this.onScheduleTypeChange()
  }

  // 课表的时间切换
  private async onTimeChanged (data: string) {
    if (data === '前') {
      if (this.showTypeChoose === '周') {
        this.weekI = this.weekI - 1
        this.currentChoose = moment(this.currentChoose).subtract(1, 'week')
      }
    } else if (data === '本周') {
      this.weekI = 0
      this.currentChoose = this.today
    } else if (data === '后') {
      if (this.showTypeChoose === '周') {
        this.weekI = this.weekI + 1
        this.currentChoose = moment(this.currentChoose).add(1, 'week')
      }
    }
    this.onScheduleTypeChange()
  }

  private async onScheduleTypeChange () {
    await this.initSummaryTimetable()
    this.initScheduleList()
  }
}
